import { HttpService, UCCLookUpProvider, UCCOperProvider, UCCService, UCCViewProvider } from '@lk/api'

export const makeUCCService = (http: HttpService, baseUrl: string) =>
  new UCCService(
    new UCCLookUpProvider(http, baseUrl),
    new UCCViewProvider(http, baseUrl),
    new UCCOperProvider(http, baseUrl),
  )
